// Librería de Excel (SheetJS), UN solo cargador para todo el sistema.
//
// Seguridad, tanda 5: antes cada módulo la traía de cdnjs en la versión 0.18.5, que tiene
// fallas conocidas al LEER archivos (y aquí se leen estados de cuenta de terceros). Ahora es
// la 0.20.3 oficial de SheetJS, guardada en el propio sistema (public/vendor): no depende de
// un sitio externo y la política de seguridad del navegador ya no tiene que permitirlo.
// Se carga solo cuando hace falta (al exportar o importar), no al abrir la app.
const URL_XLSX = '/vendor/xlsx-0.20.3.full.min.js';

let cargando = null;
export function loadXLSX() {
  if (window.XLSX) return Promise.resolve(window.XLSX);
  if (!cargando) {
    cargando = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = URL_XLSX;
      s.onload = () => resolve(window.XLSX);
      s.onerror = () => { cargando = null; reject(new Error('No se pudo cargar la librería de Excel.')); };
      document.head.appendChild(s);
    });
  }
  return cargando;
}
